import { initialize, setProps } from '../redux/Reducers/createPostReducer';
import { gcGroupInitialState, setGroupInfo } from '../redux/Reducers/gcGroupReducer'
import { AppDispatch } from "../redux/store";
import { isGroupLeader } from './utils';

export type CreatePostType =
  'UserPost' |             // みんなの投稿
  'GroupPublicPost' |      // グループのみんなの投稿
  'InsideGroupPost' |      // グループ内の投稿
  'GroupPrivateUserPost' | // グループ内のプライベート投稿
  'GroupEventPost'         // イベント
export type CreatePostLocationState = {
  initialPrivateUsers: any[]
}
type State = {
  state: CreatePostLocationState
}

export type Member = {
  id?: any,
  user_id: number,
  nickname: string,
  image: any
}

/**
 * posts を作成/編集するための画面に渡す情報。
 * 設定漏れ防止として扱うすべての情報を設定する (情報が無い場合もあるため null を許容)。
 *
 * @param type
 * @param user
 * @param group APIから取得した member_group または reducer で設定した groupInfo
 * @param initialPrivateUsers
 * @returns
 */
export const createNewPostState = (type: CreatePostType, user: Exclude<any, null | undefined>, group: any, initialPrivateUsers: any[], dispatch: AppDispatch): State => {
  if (group) {
    setGroupInfoReducer(group, user, dispatch)
  }

  dispatch(initialize({createPostType: type}))

  return {
    state: {
      initialPrivateUsers: initialPrivateUsers
    }
  }
}

/**
 * posts を作成/編集するための画面に渡す情報。
 * 設定漏れ防止として扱うすべての情報を設定する (情報が無い場合もあるため null を許容)。
 *
 * @param post
 * @param user
 * @param group APIから取得した member_group または reducer で設定した groupInfo
 * @returns
 */
export const createUpdatingPostState = (post: Exclude<any, null | undefined>, user: Exclude<any, null | undefined>, group: any, dispatch: AppDispatch): State => {
  if (group) {
    setGroupInfoReducer(group, user, dispatch)
  }
  dispatch(setProps(post))

  return {
    state: {
      initialPrivateUsers: []
    }
  }
}

const setGroupInfoReducer = (group: any, user: any, dispatch: AppDispatch): void => {
  // member_group テーブルの内容を reducer のフィールドに変換
  // See: gcGroupReducer
  dispatch(
    setGroupInfo({
      id: group.id ? Number(group.id) : gcGroupInitialState.id,
      user: group.user ?? group.owner,
      owner: group.owner,
      edit: gcGroupInitialState.edit,
      isLoading: gcGroupInitialState.isLoading,
      isSuccess: gcGroupInitialState.isSuccess,
      member_groups: group.member_groups ?? gcGroupInitialState.member_groups,
      memberGroupUsers: group.memberGroupUsers ?? group.hasOwnProperty('member_group_users') ? group.member_group_users : gcGroupInitialState.memberGroupUsers,
      groupName: group.groupName ?? group.name,
      groupImage: group.groupImage,
      groupIsPublic: group.groupIsPublic ?? group.group_type,
      piiRequired: group.piiRequired ?? group.personal_information_needed,
      isPaid: group.isPaid ?? group.is_paid,
      groupMainImage: group.groupMainImage,
      groupDesc: group.groupDesc ?? group.description,
      groupAnnouncements: group.groupAnnouncements ?? group.member_group_activities,
      groupWebURLs: group.groupWebURLs ?? group.social_links,
      groupApprovalRequired: group.groupApprovalRequired ?? group.approval_required,
      groupIsLimited: group.groupIsLimited ?? group.group_type === 'Public',
      groupMemberShipFeeAmount: group.groupMemberShipFeeAmount ?? group.joining_fee_amount,
      isMonthly: group.isMonthly ?? group.fee_type === 'monthly',
      groupPaymentField: group.groupPaymentField ?? group.fee_amount,
      groupPaymentDescription: group.groupPaymentDescription ?? group.fee_explanation,
      role: group.role ?? (isGroupLeader(group, user) ? 'leader' : group.role),
      posts_count: group.posts_count
    })
  );
}

export const getCreatePostType = (group_post_type: 'public' | 'private' | 'private_users'): CreatePostType => {
  switch(group_post_type) {
    case 'public': {
      return 'GroupPublicPost'
    }
    case 'private': {
      return 'InsideGroupPost'
    }
    default: {
      // 実装ミスの際に画面がエラーで落ちないように default で定義
      // 誤って全体公開するような Post を作成してしまうことを防ぐ
      return 'GroupPrivateUserPost'
    }
  }
}
